module.exports = __webpack_public_path__ + "img/booking-image.4071fa52.jpg";